import { defineMessages } from 'react-intl';

export default defineMessages({
    bankAccNumMandatoryTitle: {
        id: 'sasria.bankservices.bankAccNumMandatoryTitle',
        defaultMessage: 'Error'
    },
    bankAccNumMandatoryMessage: {
        id: 'sasria.bankservices.bankAccNumMandatoryMessage.',
        defaultMessage: 'Bank Account Number is mandatory'
    },

    bankCodeNumMandatoryTitle: {
        id: 'sasria.bankservices.bankCodeNumMandatoryTitle',
        defaultMessage: 'Error'
    },
    bankCodeNumMandatoryMessage: {
        id: 'sasria.bankservices.bankCodeNumMandatoryMessage.',
        defaultMessage: 'Branch Code is mandatory'
    },

    bankAccTypeMandatoryTitle: {
        id: 'sasria.bankservices.bankAccTypeMandatoryTitle',
        defaultMessage: 'Error'
    },
    bankAccTypeMandatoryMessage: {
        id: 'sasria.bankservices.bankAccTypeMandatoryMessage.',
        defaultMessage: 'Account Type is mandatory'
    },

    bankNameMandatoryTitle: {
        id: 'sasria.bankservices.bankNameMandatoryTitle',
        defaultMessage: 'Error'
    },
    bankNameMandatoryMessage: {
        id: 'sasria.bankservices.bankNameMandatoryMessage.',
        defaultMessage: 'Bank Name is mandatory'
    },

    AVSValidationTitle: {
        id: 'sasria.bankservices.AVSValidationTitle',
        defaultMessage: 'Bank data cannot be saved'
    },
    AVSValidationMessage: {
        id: 'sasria.bankservices.AVSValidationMessage.',
        defaultMessage: 'Registration Number is mandatory for Vendor Company and Passport or Identity Number is mandatory for Vendor Contact.'
    },

    invalidBankTitle: {
        id: 'sasria.bankservices.invalidBankTitle',
        defaultMessage: 'Account number is invalid'
    },

    invalidBankMessage: {
        id: 'sasria.bankservices.invalidBankMessage',
        defaultMessage: 'Account Number should be a number up to 13 digits long, with no spaces.'
    },

    documentUploadFailed: {
        id: 'sasria.bankservices.Document Upload failed',
        defaultMessage: 'DocumentUploadFailed'
    },
    documentCannotBeUploaded: {
        id: 'sasria.bankservices.component.document-component.Sorry your document could not be uploaded at this time',
        defaultMessage: 'Sorry your document could not be uploaded at this time'
    },



});
